import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "100%" : '55%',
  },
};

export default function EditMasala({
    editMasalaInfo,
    setEdit,
    edit,
}) {
    const mainTopic = "Masala";
    const [masalaEditInfo, setMasalaEditInfo] = useState({});
    const [categoryList, setCategoryList] = useState([])

    useEffect(() => setMasalaEditInfo(editMasalaInfo), []);

    useEffect( ()  => {     
      async function fetchData() {   
       const category = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/${mainTopic}`)
       setCategoryList(category.data.response);
      }
      fetchData(); 
    },[])

    const masalaEdit = async (e) => {
        e.preventDefault();
        try {
            const masalaInserted = await axios.put(
              `https://ahlehaqserver.herokuapp.com/api/masala/${editMasalaInfo._id}`,
              masalaEditInfo
            );
    
            //if request success, will show success notification
            if (masalaInserted.data.code === 200) {
                
              setEdit(false)
              toast.success("Masala edited successfully!");
              e.target.reset();
            }
        } catch (error) {
          console.log(error);
          toast.error("Internal Server Error!");
        }
      };
    return (
        <>
        <Modal isOpen={edit} style={customStyles}>
        <h1 className="ml-4">Edit Masala</h1>

            <form onSubmit={masalaEdit}>
            <div className="row">
                <div className="col-md-6">
                <div className="form-group">
                    <label for="exampleInputEmail1" className="font-weight-bold">
                        Select category<span className="text-danger">*</span>
                    </label>
                    
                    <select
                        className="form-control rounded"
                        id="exampleInputEmail1"
                        name="category"
                        value={masalaEditInfo?.category || ""}
                        required
                        onChange={(e) =>
                            setMasalaEditInfo((prev) => ({
                            ...prev,
                            [e.target.name]: e.target.value,
                        }))
                        }
                    >
                        <option>
                            "Choose from the list"
                        </option>
                        {categoryList &&
                        categoryList.map((data) => (
                            <option value={data.category}>
                            {data.category}
                            </option>
                        ))}
                    </select>  
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                    Masala Title<span className="text-danger">*</span>
                    </label>
                    <input
                    type="text"
                    className="form-control rounded"
                    placeholder="Write Masala Title"
                    id="exampleInputPassword1"
                    name="title"
                    value={masalaEditInfo?.title || ""}
                    required
                    onChange={(e) =>
                        setMasalaEditInfo((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                        }))
                    }
                    />
                </div>
                </div>

                
                <div className="col-md-12">
                <div className="form-group">
                    <label for="exampleInputEmail1" className="font-weight-bold">
                        Write question and answer<span className="text-danger">*</span>
                    </label>
                
                            <CKEditor
                                editor={ ClassicEditor }
                                data={masalaEditInfo?.description || ""}
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setMasalaEditInfo((Prev) => ({ ...Prev, description: data }))
                                } }
                            />
                    </div>   
                </div>  
                
                        <div className="col-md-6">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                              <button
                                className="btn btn-danger rounded-pill px-4 ml-3"
                                onClick={() => setEdit(false)}
                                >
                                Close
                                </button>
                            </div>  
                         </div> 

            </div>

            
            </form>
        </Modal>   
        </>
    )
}
